import {GetHealthEmergencyLink} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHealthEmergencyLink} from 'data/usecases';
import {getHealthEmergencyEndpoint} from './get-health-emergency-endpoint';

export const makeGetHealthEmergencyLink = (useV3 = false): GetHealthEmergencyLink =>
	new RemoteGetHealthEmergencyLink(
		makeBFFApiUrl(getHealthEmergencyEndpoint(useV3)),
		makeAuthorizeHttpClientDecorator(),
	);
